import   axios                 from 'axios';
import { API_URLS            } from '../urls';
import { BackendResponse              ,
         handleError                  ,
         extractServerConflictMessage } from '../../dataTypes/backendServicesManagment/types';
import { Image               ,
         initializedImage    } from '../../dataTypes/mediaManagment/image_types';

import { getUserAgentInformations   }  from '../../utils/utils_userAgent';
import { getAppInformations         }  from '../../utils/utils_app';

import { createUpload               }  from '../fileManagment/uploadWithStore';

/**
 * Lance l'upload de l'image en arrière-plan, quelle que soit sa taille (uniformisation
 * du mécanisme d'upload : toujours par chunks, comme pour la vidéo/le document).
 */
const uploadImageInBackground = (imageId: number, imageFileToUpload: File): void => {
  const uploadConfig = {
    uploadChunkUrl: API_URLS.uploadImageChunk,
    finalizeUploadUrl: API_URLS.finalizeImageUpload,
    chunkSize: 5 * 1024 * 1024, // 5MB pour les images
    maxRetries: 3,
    enableResume: true,
    entityId: imageId,
    entityType: 'image',
    autoStart: true,
    metadata: {
      imageId: imageId,
      mediaType: 'image'
    }
  };

  const uploader = createUpload(imageFileToUpload, uploadConfig);
  console.log(`Upload image démarré en arrière-plan pour l'image ID: ${imageId}, Upload ID: ${uploader.id}`);
};

export interface BackendResponse_ImageList extends BackendResponse <Image[]>{}

export const getImageList = async (reload: boolean = false, adminId?: number): Promise<BackendResponse_ImageList> => {

  const url = API_URLS.getImageList;

  try
   {
    const response = await axios.get(url, { params: adminId ? { adminId } : {} });

    if (response.status === 200)
          {
           const images: Image[] = response.data.map((image: any) => {

              const defaultImage = initializedImage();

              const categoriesIds = image.mediaCategories?.map((category: any) => category.id) || [];
              const keywordsIds   = image.keywords?.map((keyword: any) => keyword.id) || [];

              return {
                 ...defaultImage,
                 id                  : image.id                  ?? defaultImage.id,
                 uuid                : image.uuid                ?? defaultImage.uuid,
                 publicRef           : image.publicRef                ?? defaultImage.publicRef,
                 mediaType           : image.mediaType           ?? defaultImage.mediaType,
                 name                : image.name                ?? defaultImage.name,
                 thumbnail           : image.thumbnail           ?? defaultImage.thumbnail,
                 comment             : image.comment             ?? defaultImage.comment,
                 state               : image.state               ?? defaultImage.state,
                 creationDate        : image.creationDate        ? new Date (image.creationDate.date) : defaultImage.creationDate,
                 creationIpAddress   : image.creationIpAddress   ?? defaultImage.creationIpAddress,
                 keywordsIds         : keywordsIds               ?? defaultImage.keywordsIds,
                 categoriesIds       : categoriesIds             ?? defaultImage.categoriesIds,
                 publicPortal        : image.publicPortal        ?? defaultImage.publicPortal,
                 associatedProductId : image.associatedProductId ?? defaultImage.associatedProductId,

                 visible             : image.visible             ?? defaultImage.visible,
                 active              : image.active              ?? defaultImage.active,
                 title               : image.title               ?? defaultImage.title,
                 description         : image.description         ?? defaultImage.description,
                 imageFile           : image.imageFile           ?? defaultImage.imageFile,
                 originalFile        : image.originalFile        ?? defaultImage.originalFile,

                 storageBytes        : image.storageBytes        ?? defaultImage.storageBytes,
                 storageComputedAt   : image.storageComputedAt    ? new Date (image.storageComputedAt.date) : defaultImage.storageComputedAt,
              };
           });

           return {
                    code    : 1,
                    comment : 'La récupération des images depuis le serveur est terminée.',
                    payload : images,
                  };
          }
     else {
           return handleError<Image[]>(response.status, 'Non-200 response from API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<Image[]>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<Image[]>(-102, 'Erreur inconnue');
   }
};

export interface BackendResponse_Image extends BackendResponse <Image>{}

export const getImageById = async (imageId : number): Promise<BackendResponse_Image> => {

  const baseUrl = `${API_URLS.getImageById}`;
  const url = baseUrl.replace('{id}', `${imageId}`);

  try
   {
    const response = await axios.get(url);

    if (response.status === 200)
          {
           const image = response.data

              const defaultImage = initializedImage();

              const categoriesIds = image.mediaCategories?.map((category: any) => category.id) || [];
              const keywordsIds   = image.keywords?.map((keyword: any) => keyword.id) || [];

              const imageToReturn: Image = {
                 ...defaultImage,
                 id               : image.id            ?? defaultImage.id,
                 uuid             : image.uuid          ?? defaultImage.uuid,
                 publicRef        : image.publicRef          ?? defaultImage.publicRef,
                 mediaType        : image.mediaType     ?? defaultImage.mediaType,
                 name             : image.name          ?? defaultImage.name,
                 thumbnail        : image.thumbnail     ?? defaultImage.thumbnail,
                 comment          : image.comment       ?? defaultImage.comment,
                 state            : image.state         ?? defaultImage.state,
                 creationDate     : image.creationDate  ?? defaultImage.creationDate,
                 creationIpAddress: image.creationIpAddress ?? defaultImage.creationIpAddress,
                 keywordsIds      : keywordsIds         ?? defaultImage.keywordsIds,
                 categoriesIds    : categoriesIds       ?? defaultImage.categoriesIds,
                 publicPortal     : image.publicPortal  ?? defaultImage.publicPortal,

                 active           : image.active        ?? defaultImage.active,
                 visible          : image.visible       ?? defaultImage.visible,
                 title            : image.title         ?? defaultImage.title,
                 description      : image.description   ?? defaultImage.description,
                 imageFile        : image.imageFile     ?? defaultImage.imageFile,
                 originalFile     : image.originalFile  ?? defaultImage.originalFile,
              };


           return {
                    code    : 1,
                    comment : 'La récupération de l\'image depuis le serveur est terminée.',
                    payload : imageToReturn,
                  };
          }
     else {
           return handleError<Image>(response.status, 'Non-200 response from API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<Image>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<Image>(-102, 'Erreur inconnue');
   }
};


// Fonction pour mettre à jour la visibilité d'une vidéo
export const updateImageVisibility = async (id: number, state: number): Promise<BackendResponse> => {
  const baseUrl       = `${API_URLS.patchImageVisibility}`;
  const url           = baseUrl.replace('{id}', `${id}`);
  const visibilityStr = state === 1 ? 'true' : 'false';

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json',
  };

  try {
    const response = await axios.patch(url, { visibilityStr }, { headers });

    if (response.status === 200 || response.status === 204) {
      return {
        code    : 1,
        comment : 'Video visibility updated successfully.',
        payload : {} as any
      };
    } else {
      return handleError<void>(response.status, 'Non-200/204 response from API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Network error');
  }
};

export const updateImage = async ( id                   : number      ,
                                   active               : boolean     ,
                                   title                : string      ,
                                   description          : string      ,
                                   imageFileToUpload    : File | null ,
                                   categoriesIds        : number[]    ,
                                   keywordsIds          : number[]    ,
                                   publicPortal         : boolean     ,
                                   adminId?             : number   ): Promise<BackendResponse> => {

  const categoriesIdsStr : string = categoriesIds.join (',');
  const keywordsIdsStr   : string = keywordsIds.join (',');

  const url = `${API_URLS.patchImage}`;
  
  const formData = new FormData();

                     formData.append ( 'id'                , `${id}`                 );
                     formData.append ( 'active'            , active.toString()       );
                     formData.append ( 'title'             , title                   );
                     formData.append ( 'description'       , description             );
                     formData.append ( 'categoriesIdsStr'  , categoriesIdsStr        );
                     formData.append ( 'keywordsIdsStr'    , keywordsIdsStr          );
                     formData.append ( 'publicPortal'      , publicPortal.toString() );
  if ( adminId )    { formData.append ( 'adminId'           , adminId.toString()      ); }
  // Pas de fichier ici : si un nouveau fichier est fourni, il est uploadé séparément par chunks.

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'multipart/form-data',
	'User-Agent-Informations': `${userAgentInformations}`,
	'App-Informations': `${appInformations}`,
  };

  try
   {
    const response = await axios.post(url, formData, { headers });  // Utilisation de PATCH ici

    console.log (response)

    if (response.status === 200 || response.status === 201 || response.status === 204)
	      {
           if ( imageFileToUpload !== null ) { uploadImageInBackground ( id , imageFileToUpload ); }

           return {
                    code    : 1,
                    comment : 'Image updated successfully.',
                    payload : {} as any
                  };
          }
	 else {
           return handleError<void>(response.status, 'Non-200/204 response from API');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
  }
};

// Fonction pour supprimer une vidéo
export const deleteImage = async ( id       : number ,
                                   adminId? : number ): Promise<BackendResponse> => {
									   
  const baseUrl = `${API_URLS.deleteImage}`;
  const url = baseUrl.replace('{id}', `${id}`);

  console.log ('deleteImage', url, id, adminId )

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();
  
  const headers = {
    'Accept': 'application/ld+json',
	'User-Agent-Informations': `${userAgentInformations}`,
	'App-Informations': `${appInformations}`,
    'X-Admin-Id': adminId ?? '' 				   
  };

  try 
   {
    const response = await axios.delete(url, { headers });

  console.log ('deleteImage', response )


    if (response.status === 204) 
	      {  // Suppression réussie, sans contenu retourné
           return {
                    code    : 1,
                    comment : 'The image has been successfully deleted.',
                    payload : {} as any
                  };
          } 
	 else {
           return handleError<void>(response.status, 'Error deleting the video');
          }
   } 
  catch (error)
   {
  console.log ('deleteImage', error )

    if (axios.isAxiosError(error))
	 {
      if (error.response?.status === 409) {
        return {
          code    : -103,
          // Cf. api_audioSlideshow : la phrase du serveur nomme le diaporama qui retient cette image.
          comment : extractServerConflictMessage(error.response?.data),
          payload : {} as any
        };
      }
      if (error.response?.status === 404) {
        return {
          code    : -104,
          comment : 'The image no longer exists.',
          payload : {} as any
        };
      }
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
   }
};

// Fonction pour créer une nouvelle vidéo
export const createImage = async ( active            : boolean     ,
                                   title             : string      ,
                                   description       : string      ,
                                   imageFileToUpload : File | null ,
                                   categoriesIds     : number[]    ,
                                   keywordsIds       : number[]    ,
                                   publicPortal      : boolean     ,
                                   adminId?          : number      ): Promise<BackendResponse> => {

  console.log ('createImage adminId', adminId)

  const categoriesIdsStr : string = categoriesIds.join(',');
  const keywordsIdsStr   : string = keywordsIds.join(',');

  const url = `${API_URLS.createImage}`;

  const formData = new FormData();

                     formData.append ( 'active'            , active.toString()       );
                     formData.append ( 'title'             , title                   );
                     formData.append ( 'description'       , description             );
                     formData.append ( 'categoriesIdsStr'  , categoriesIdsStr        );
                     formData.append ( 'keywordsIdsStr'    , keywordsIdsStr          );
                     formData.append ( 'publicPortal'      , publicPortal.toString() );
  if ( adminId )    { formData.append ( 'adminId'           , adminId.toString()      ); }
  // Pas de fichier ici : la fiche est créée d'abord (métadonnées seules), puis le fichier
  // est uploadé séparément par chunks (uniforme quelle que soit sa taille, comme pour la vidéo).

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'multipart/form-data',
	'User-Agent-Informations': `${userAgentInformations}`,
	'App-Informations': `${appInformations}`,
  };

  try
   {
    const response = await axios.post(url, formData, { headers });  // Utilisation de POST pour la création

    if (response.status === 201)
          {
           const imageId = response.data.id;

           if ( imageFileToUpload !== null ) { uploadImageInBackground ( imageId , imageFileToUpload ); }

           return {
                    code    : 1,
                    comment : imageFileToUpload !== null ? 'Image created successfully. Upload started in background.' : 'Image created successfully.',
                    payload : imageId
                  };
          }
     else {
           return handleError<void>(response.status, 'Error creating the image');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, 'Unknown error');
   }
};

export interface DownloadProgress {
  loaded: number;
  total: number;
}

export const downloadImageBlob = async ( image       : Image                                ,
                                         onProgress? : (progress: DownloadProgress) => void ): Promise<Image> => {
											 
  const baseUrl = `${API_URLS.getImageFile}`;
  const url = baseUrl.replace("{id}", `${image.id}`);

  console.log("🔊 Téléchargement de l'image :", url);

  if (!image.imageFile) 
   {
    console.warn("⚠️ Aucun imageFile défini pour cette image.");
    return image;
   }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";

    // Gestion de la progression
    xhr.onprogress = (event) => {
      if (onProgress && event.lengthComputable) {
        onProgress({
          loaded: event.loaded,
          total: event.total,
        });
      }
    };

    // Succès
    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = xhr.response as Blob;
        const objectURL = URL.createObjectURL(blob);
        console.log("✅ Téléchargement terminé :", image.imageFile);
        resolve({
          ...image,
          fileBlob: blob,
          objectURL,
        });
      } else {
        console.error("❌ Erreur HTTP lors du téléchargement :", xhr.status);
        reject(new Error(`Erreur HTTP ${xhr.status}`));
      }
    };

    // Erreur réseau
    xhr.onerror = () => {
      console.error("❌ Erreur réseau lors du téléchargement de l'image");
      reject(new Error("Erreur réseau lors du téléchargement de l'image"));
    };

    xhr.send();
  });
};

export const releaseImageBlob = (image: Image): Image => {
	
  if (image.objectURL) 
   {
    URL.revokeObjectURL(image.objectURL);
   }

  return {
           ...image,
           fileBlob  : undefined,
           objectURL : undefined,
         };
};


export const getImageFileUrl = (imageId: number): string => {
  const baseUrl = `${API_URLS.getImageFile}`;
  return baseUrl.replace('{id}', `${imageId}`);
};

export interface BackendResponse_ImageUsage extends BackendResponse<number[]> {}

export const getImageUsage = async (imageId : number): Promise<BackendResponse_ImageUsage> => {

  const baseUrl = `${API_URLS.getImageUsage}`;
  const url = baseUrl.replace('{id}', `${imageId}`);

  try 
   {
    const response = await axios.get(url);

    if (response.status === 200) 
          {
           return {
                    code    : 1,
                    comment : 'The retrieval of image usage is complete.',
                    payload : response.data,
                  };
          } 
     else {
           return handleError<number[]>(response.status, 'Non-200 response from API');
          }
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
     {
      return handleError<number[]>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<number[]>(-102, 'Unknown error');
  }
};
